import React from 'react';
import { Pill } from './PillTrigger.styled';
import { useChromeLayout } from './ChromeContext';

export interface PillTriggerProps {
  label: string;
  ariaLabel: string;
  caret: React.ReactNode;
  open: boolean;
  tone?: 'bar' | 'readout';
  onClick: () => void;
  onMouseDown: React.MouseEventHandler<HTMLButtonElement>;
  testId: string;
}

/** A text button that opens a menu: the shading menu, the grid readout. */
const PillTrigger = React.forwardRef<HTMLButtonElement, PillTriggerProps>(function PillTrigger(
  { label, ariaLabel, caret, open, tone = 'bar', onClick, onMouseDown, testId },
  ref,
) {
  const { narrow } = useChromeLayout();
  return (
    <Pill
      ref={ref}
      type="button"
      aria-label={ariaLabel}
      aria-haspopup="menu"
      aria-expanded={open}
      $tone={tone}
      $narrow={narrow}
      $open={open}
      onClick={onClick}
      onMouseDown={onMouseDown}
      data-testid={testId}
    >
      <span>{label}</span>
      {caret}
    </Pill>
  );
});

export default PillTrigger;
